/** Single source for the public phone number — must match Google Business Profile. */
export const CONTACT_PHONE_E164 = '+905300808878';
export const CONTACT_PHONE_DISPLAY = '0530 080 88 78';

/** Anchor target for "jump to form" links (e.g. /tr/iletisim#contact-form). */
export const CONTACT_FORM_ID = 'contact-form';
export const CONTACT_FORM_FIRST_FIELD_ID = 'contact-projectType';
